import React, { useEffect, useState } from "react";
import HipervinCole from "./DOM/HipervinCole";
import SelectBuscadorCole from "./componentesSecundarios/SelectBuscadorCole";
import SelectOrderCole from "./componentesSecundarios/SelectOrderCole";
import SelectBuscadorUno from "./componentesSecundarios/SelectBuscadorUno";
import SelectOrderUno from "./componentesSecundarios/SelectOrderUno";
import {useStoreGlobal} from '../../stores/Global'
import {useShallow} from 'zustand/react/shallow'
const SelectBuscador = () => {
  const _filtros= useStoreGlobal(useShallow((state) => state._filtros));
    const [showOrderTodo, setShowOrderTodo] = useState(true);
    const [showBuscarEn, setShowBuscarEn] = useState(false);
    const [showOrdenaen, setShowOrdenaen] = useState(false);
    let var_ingles = "es";
    if (window.location.href.indexOf("en.") > -1) {
        var_ingles = "en";
    }
    let coleccion=_filtros.coleccion;
  useEffect(() => {
    var  coleccionInfo = _filtros.coleccion;
    if ((coleccionInfo == "Indicadores") || (coleccionInfo == "Indicators")){
      coleccionInfo = _filtros.radioIndicador === "BancoBieBise" ? "BieBise" : "Indicadores";
    }
    HipervinCole(
      coleccionInfo,
      var_ingles
    );
    if ((coleccion !== "Todo") && (coleccion !== "All") && (coleccion !== "Mapas") && (coleccion !== "Herramientas") && (coleccion !== "Tools")){
      setShowOrderTodo(false);
      setShowBuscarEn(true);
      setShowOrdenaen(true);
    }
    else if ((coleccion === "Mapas") || (coleccion === "Herramientas")){
      setShowOrderTodo(false);
      setShowBuscarEn(false);
      setShowOrdenaen(true);
    } 
    else{
      setShowOrderTodo(true);
      setShowBuscarEn(false);
      setShowOrdenaen(false);
    }
}, [coleccion,_filtros]);
  return (
    <div id="BuscadorOrdenador">
      <div className="row" style={{ paddingLeft: "10px" }}>
        <SelectBuscadorCole/>
        {showOrderTodo && (
          <SelectOrderCole />
        )}
        {showBuscarEn && (
          <SelectBuscadorUno />
        )}
        {showOrdenaen && (
          <SelectOrderUno/>
        )}
      </div>
    </div>
  );
}
export default SelectBuscador ;